import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';

const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));

// ==============================|| AUTH ROUTING ||============================== //


const LoginRoutes = {
  index: true,
  element: <LoginPage />
};

export default LoginRoutes;
